import { useEffect, useRef, useState } from "react";
import { Download, Share2 } from "lucide-react";

const SITE_URL = "https://abcguitarlessons.com";

export const ShareCard = ({ result }) => {
  const canvasRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const draw = async () => {
      await document.fonts.ready;
      const c = canvasRef.current;
      if (!c || cancelled) return;
      const ctx = c.getContext("2d");
      const W = 1080;
      const H = 1350;

      ctx.fillStyle = "#f7f6f2";
      ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#DB0909";
      ctx.fillRect(0, 0, W, 14);
      ctx.strokeStyle = "rgba(28,22,16,0.25)";
      ctx.lineWidth = 2;
      ctx.strokeRect(48, 48, W - 96, H - 96);

      ctx.fillStyle = "#DB0909";
      ctx.font = "italic 900 60px 'Playfair Display', serif";
      ctx.fillText("abc", 96, 175);
      ctx.fillStyle = "#1c1610";
      ctx.font = "700 24px 'JetBrains Mono', monospace";
      ctx.fillText("G U I T A R   L E S S O N S", 205, 168);

      ctx.fillStyle = "#1c1610";
      ctx.font = "900 108px 'Playfair Display', serif";
      ctx.fillText("I'm learning", 96, 425);
      ctx.fillText("guitar with", 96, 550);
      ctx.fillStyle = "#DB0909";
      ctx.font = "italic 900 108px 'Playfair Display', serif";
      ctx.fillText("Sanjith.", 96, 675);

      ctx.fillStyle = "#4a3e30";
      ctx.font = "500 28px 'JetBrains Mono', monospace";
      ctx.fillText(String(result.course_name || "").toUpperCase(), 96, 795);
      ctx.fillText(`${String(result.batch_name || "").toUpperCase()} · LIVE ONLINE`, 96, 845);

      ctx.strokeStyle = "rgba(28,22,16,0.2)";
      ctx.beginPath();
      ctx.moveTo(96, 925);
      ctx.lineTo(W - 96, 925);
      ctx.stroke();
      ctx.fillStyle = "#DB0909";
      [0.15, 0.38, 0.62, 0.85].forEach((p) => {
        ctx.beginPath();
        ctx.arc(96 + (W - 192) * p, 925, 7, 0, Math.PI * 2);
        ctx.fill();
      });

      ctx.fillStyle = "#1c1610";
      ctx.fillRect(96, 1000, W - 192, 130);
      ctx.fillStyle = "#f7f6f2";
      ctx.font = "700 32px 'JetBrains Mono', monospace";
      ctx.textAlign = "center";
      ctx.fillText("JOIN ME → ABCGUITARLESSONS.COM", W / 2, 1080);
      ctx.textAlign = "left";

      ctx.fillStyle = "#950606";
      ctx.font = "500 26px 'JetBrains Mono', monospace";
      ctx.fillText(SITE_URL, 96, 1210);
      ctx.fillStyle = "#4a3e30";
      ctx.font = "300 26px 'Manrope', sans-serif";
      ctx.fillText("English · Hindi · Malayalam", 96, 1252);
      if (!cancelled) setReady(true);
    };
    draw();
    return () => { cancelled = true; };
  }, [result]);

  const toBlob = () => new Promise((res) => canvasRef.current.toBlob(res, "image/png"));

  const download = async () => {
    const blob = await toBlob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "learning-guitar-with-sanjith.png";
    a.click();
  };

  const share = async () => {
    const blob = await toBlob();
    const file = new File([blob], "learning-guitar-with-sanjith.png", { type: "image/png" });
    const text = `I'm learning guitar with Sanjith at ABC Guitar Lessons! 🎸 Join me → ${SITE_URL}`;
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], text });
        return;
      } catch (e) {
        if (e.name === "AbortError") return;
      }
    }
    await download();
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };

  return (
    <div data-testid="share-card" className="mt-10 border-t border-[rgba(28,22,16,0.12)] pt-8 flex flex-col items-center">
      <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#950606]">Tell your friends — post it on your status</p>
      <canvas
        ref={canvasRef}
        width={1080}
        height={1350}
        data-testid="share-card-canvas"
        className="mt-5 w-full max-w-[260px] border border-[rgba(28,22,16,0.18)] shadow-[6px_6px_0_rgba(28,22,16,0.12)]"
      />
      <div className="mt-5 flex flex-wrap justify-center gap-3">
        <button
          data-testid="share-card-share-btn"
          disabled={!ready}
          onClick={share}
          className="vibe inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase bg-[#DB0909] text-[#f7f6f2] px-6 py-3 hover:bg-[#950606] transition-colors duration-300 disabled:opacity-50"
        >
          <Share2 size={14} /> Share to WhatsApp
        </button>
        <button
          data-testid="share-card-download-btn"
          disabled={!ready}
          onClick={download}
          className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase border border-[rgba(28,22,16,0.3)] text-[#1c1610] px-6 py-3 hover:border-[#DB0909] hover:text-[#DB0909] transition-colors duration-300 disabled:opacity-50"
        >
          <Download size={14} /> Download card
        </button>
      </div>
    </div>
  );
};
